import { BaseFieldFilter, NativeFieldFilter } from 'api/dashboard/widget';
import { TextField } from 'components/organisms/tasks/fields';
import { Operation } from 'components/organisms/tasks/filters/operations';
import {
  TextFieldFilter,
  TextFieldFilterOperationType,
} from 'components/organisms/tasks/filters/text';
import { unreachable } from '../../unreachable';

const toApiFormat = (filter: TextFieldFilter): BaseFieldFilter => {
  switch (filter.type) {
    case TextFieldFilterOperationType.IsEmpty:
      return {
        operation: Operation.IsEmpty,
        sourceType: filter.field.sourceType,
      };
    case TextFieldFilterOperationType.IsNotEmpty:
      return {
        operation: Operation.IsNotEmpty,
        sourceType: filter.field.sourceType,
      };
    case TextFieldFilterOperationType.Contains:
      return {
        operation: Operation.Contains,
        value: filter.value,
        sourceType: filter.field.sourceType,
      };
    case TextFieldFilterOperationType.DoesNotContain:
      return {
        operation: Operation.NotContains,
        value: filter.value,
        sourceType: filter.field.sourceType,
      };
    case TextFieldFilterOperationType.IsExactly:
      return {
        operation: Operation.Value,
        value: filter.value,
        sourceType: filter.field.sourceType,
      };
    case TextFieldFilterOperationType.IsNotExactly:
      return {
        operation: Operation.IsNot,
        value: filter.value,
        sourceType: filter.field.sourceType,
      };
    default:
      return unreachable(filter);
  }
};

const toType = (operation: Operation): TextFieldFilterOperationType => {
  switch (operation) {
    case Operation.IsEmpty:
      return TextFieldFilterOperationType.IsEmpty;
    case Operation.IsNotEmpty:
      return TextFieldFilterOperationType.IsNotEmpty;
    case Operation.Contains:
      return TextFieldFilterOperationType.Contains;
    case Operation.NotContains:
      return TextFieldFilterOperationType.DoesNotContain;
    case Operation.Value:
      return TextFieldFilterOperationType.IsExactly;
    case Operation.IsNot:
      return TextFieldFilterOperationType.IsNotExactly;
    case Operation.NoneOf:
    case Operation.OneOf:
    case Operation.HasValue:
    case Operation.IsNull:
    default:
      return unreachable(operation as never);
  }
};

const parse = (
  { operation, value }: NativeFieldFilter,
  field: TextField,
): TextFieldFilter => {
  const type = toType(operation);

  switch (type) {
    case TextFieldFilterOperationType.IsEmpty:
    case TextFieldFilterOperationType.IsNotEmpty:
      return { field, type };
    case TextFieldFilterOperationType.Contains:
    case TextFieldFilterOperationType.DoesNotContain:
    case TextFieldFilterOperationType.IsExactly:
    case TextFieldFilterOperationType.IsNotExactly: {
      const string = (value ? JSON.parse(`"${value}"`) : null) as string | null;

      return { field, type, value: string == null ? undefined : string };
    }
    default:
      return unreachable(type);
  }
};

export const TextFilter = {
  toApiFormat,
  parse,
};
